import { DiagnosticsEndpoint } from '@bindoc-projects/app-config-domain-lib';

/**
 * Hardcoded external (non-BinDoc) endpoints that all apps should test
 * for connectivity on the diagnostics page.
 */
export const EXTERNAL_DIAGNOSTICS_ENDPOINTS: DiagnosticsEndpoint[] = [
  {
    name: '*.web.core.windows.net',
    endpointKeys: [],
    origin: 'https://bindocwebassets.z1.web.core.windows.net',
    healthCheckUrl:
      'https://bindocwebassets.z1.web.core.windows.net/img/bindoc/bindoc_logo_300_100.png',
    docPath: '/img/bindoc/bindoc_logo_300_100.png',
    description: 'Externer SSO Dienstleister',
  },
  {
    name: 'ingress.europe-west4.gcp.dash0.com',
    endpointKeys: [],
    origin: 'https://ingress.europe-west4.gcp.dash0.com',
    healthCheckUrl: 'https://ingress.europe-west4.gcp.dash0.com',
    docPath: '/',
    description: 'Externer Anbieter Fehler-Analyse',
  },
  {
    name: 'api.mapbox.com',
    endpointKeys: [],
    origin: 'https://api.mapbox.com',
    healthCheckUrl: 'https://api.mapbox.com',
    docPath: '/',
    description: 'Externer Anbieter für Karten',
  },
];
